import React, { Component } from 'react';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from './components/Table';
import API from '../../services/API';

class ZeroPark extends Component {
    constructor() {
        super();

        this.state = {
            subidValues: [],
            report: [],
            reportTotal: {},
            sortParam: null,
            sortOrder: 1,
            isLoading: false
        };

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
        this.handlePageSelect = this.handlePageSelect.bind(this);
    }

    componentDidMount() {
        this.loadSubid();
    }

    componentWillUpdate(nextProps, nextState) {
        const { report, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(report, sortParam, sortOrder);

            this.setState({ report });
        }
    }

    sortReport(report, sortParam, sortOrder) {
        report.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    handleFieldChange(event) {
        const { value, name } = event.target;

        this.setState({
            [name]: value
        });
    }

    handleSubmit(filters) {
        this.setState({ isLoading: true });

        API.ZeroPark.get(filters).then(({ report, total }) => {
            this.setState({ report, reportTotal: total, isLoading: false })
        });
    }

    loadSubid() {
        API.ZeroPark.getSubid()
            .then(subid => this.setState({ subidValues: subid, isLoading: false }));
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    handlePageSelect(activePage) {
        this.setState({ activePage });
    }

    getTable() {
        const { report, reportTotal, activePage } = this.state;

        return report.length ?
            <Table report={report} total={reportTotal} activePage={activePage} onSortChange={this.handleSort} /> :
            <p>No Data</p>
    }

    render() {
        const { isLoading, subidValues } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="ZeroPark"/>
                <Form onSubmit={this.handleSubmit} subidValues={subidValues}/>

                {this.getTable()}
            </Container>
        );
    }
}

export default ZeroPark;


// WEBPACK FOOTER //
// ./src/scenes/ZeroPark/index.js